import React from 'react';
import {Link} from 'react-router-dom';
import MediaQuery from 'react-responsive';
import ContactPersonListDivs from './ContactPersonListDivs';
import ContactPersonListTable from './ContactPersonListTable';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

const ContactPersonListRedux = ({contactPersons, onClone, onDelete, listId, companyId, intl}) => {

    return (
        <div>
            <div className="row">
                <div className="col-sm-6">
                    <MediaQuery query='(max-device-width: 360px)'>
                        <h2 className="mb-3">{intl.formatMessage(messages.contactPersonListTitle)}</h2>
                    </MediaQuery>
                    <MediaQuery query='(min-device-width: 361px)'>
                        <h1 className="mb-3">{intl.formatMessage(messages.contactPersonListTitle)}</h1>
                    </MediaQuery>
                </div>
                <div className="col-sm-6 pt-2">
                    <Link to="/kontaktperson/skab" className="btn btn-primary waves-effect pull-right">
                        {intl.formatMessage(messages.contactPersonCreate)}
                    </Link>
                </div>
            </div>
            <MediaQuery query='(max-device-width: 768px)'>
                <ContactPersonListDivs
                    contactPersons={contactPersons}
                    onClone={onClone}
                    onDelete={onDelete}
                />
           </MediaQuery>
            <MediaQuery query='(min-device-width: 769px)'>
                <ContactPersonListTable
                    contactPersons={contactPersons}
                    onClone={onClone}
                    onDelete={onDelete}
                    listId={listId}
                    companyId={companyId}
                />
            </MediaQuery>
        </div>
    );
};

export default injectIntl(ContactPersonListRedux);


// WEBPACK FOOTER //
// ./web/src/components/contact-person/ContactPersonListRedux.jsx